module.exports = __webpack_public_path__ + "media/images/ohap_my courses-8b317c733222e9908016c3c9fc2eedce.png";